<script>
const IMAGES = [
    {
        src: require('../assets/images/img_2.png'),
        title: 'Berlin, Germany',
    },
    {
        src: require('../assets/images/img_1.png'),
        title: 'Vienna, Austria',
    },
    {
        src: require('../assets/images/img_3.png'),
        title: 'Vienna, Austria',
    },
    {
        src: require('../assets/images/img_4.png'),
        title: 'Paris, France',
    },
    {
        src: require('../assets/images/img_5.png'),
        title: 'Berlin, Germany',
    },
];

export default {
    data() {
        return {
            startingPoint: 0,
            prevPosition: 0,
            currentPosition: 0,
            images: IMAGES,
        };
    },
    mounted() {
        window.addEventListener('mousedown', this.onMouseDown);
        window.addEventListener('mousemove', this.onMouseMove);
        window.addEventListener('mouseup', this.onMouseUp);
    },
    methods: {
        onMouseDown(e) {
            this.startingPoint = e.clientX;
        },
        onMouseMove(e) {
            if (this.startingPoint === 0) {
                return;
            }

            const mouseDelta = (parseFloat(this.startingPoint) - e.clientX) * 0.9;
            const maxDelta = window.innerWidth * 0.6;

            let percentage = (mouseDelta / maxDelta) * -100 + this.prevPosition;
            percentage = Math.min(0, percentage);
            percentage = Math.max(percentage, -81);
            this.currentPosition = percentage;

            this.updateStyles();
        },
        onMouseUp() {
            this.startingPoint = 0;
            this.prevPosition = this.currentPosition;
        },
        updateStyles() {
            this.$refs.track.animate(
                {
                    transform: `translate(${this.currentPosition}%, -50%)`,
                },
                { duration: 1200, fill: 'forwards' }
            );
            const images = this.$refs.track.getElementsByTagName('img');
            for (const image of images) {
                image.animate(
                    {
                        objectPosition: `${this.currentPosition + 100}% 50%`,
                    },
                    { duration: 1200, fill: 'forwards' }
                );
            }
        },
        onClick(image) {
            this.$emit('showDetails', image);
        },
    },
};
</script>

<template>
    <div ref="track" class="image-container">
        <img
            v-for="image in images"
            :key="image.src"
            :src="image.src"
            draggable="false"
            @click="onClick(image)"
        />
    </div>
</template>

<style lang="postcss" scoped>
.image-container {
    display: flex;
    gap: 4vmin;
    position: absolute;
    top: 50%;
    left: calc(50% - 20vmin);
    transform: translate(0, -50%);
}

.image-container > img {
    width: 40vmin;
    height: 56vmin;
    object-fit: cover;
    object-position: 100% 50%;
    border-radius: 4px;
}
</style>
